import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ANY_QUERY_TIMEOUT, CustomSearchResults } from '@search/const';
import {
  OccSearchSuggestionsAnyQueryService,
  OccSearchSuggestionsSolrService,
  SearchActions,
} from '@search/data-access';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap, take, timeout } from 'rxjs/operators';

@Injectable()
export class SearchSuggestionsEffects {
  loadSearchSuggestions$: Observable<
    SearchActions.SearchSuggestionsLoadSuccess | SearchActions.SearchSuggestionsLoadFail
  > = createEffect(() =>
    this.actions$.pipe(
      ofType(SearchActions.LOAD_SEARCH_SUGGESTIONS),
      map((action: SearchActions.SearchSuggestionsLoad) => action.payload),
      switchMap((term: string) => {
        return this.occSearchSuggestionsAnyQueryService.loadCustomSuggestions(term).pipe(
          timeout(ANY_QUERY_TIMEOUT),
          take(1),
          map((res: CustomSearchResults) => {
            return new SearchActions.SearchSuggestionsLoadSuccess({ ...res, freeTextSearch: term });
          }),
          catchError(() => {
            return this.occSearchSuggestionsSolrService.loadCustomSuggestions(term).pipe(
              map((res: CustomSearchResults) => {
                return new SearchActions.SearchSuggestionsLoadSuccess({ ...res, freeTextSearch: term });
              }),
              catchError((error: unknown) => {
                return of(new SearchActions.SearchSuggestionsLoadFail(error));
              }),
            );
          }),
        );
      }),
    ),
  );

  constructor(
    private actions$: Actions,
    private occSearchSuggestionsAnyQueryService: OccSearchSuggestionsAnyQueryService,
    private occSearchSuggestionsSolrService: OccSearchSuggestionsSolrService,
  ) {}
}
